// extracted by mini-css-extract-plugin
module.exports = {"error":"ContentBlueprintDropzone_error__FAwaN","message":"ContentBlueprintDropzone_message__1MnkS","dropzone":"ContentBlueprintDropzone_dropzone__3ieQ9"};